import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 140) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div className="topbar-header">
        <header className="header-area style-2" style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000, backgroundColor: isScrolled ? "black" : "transparent", transition: "background-color 0.3s ease" }}>
          <div className="d-lg-none d-flex justify-content-between align-items-center w-100">
            <div className="company-logo">
              <Link to="/">
                <img src="/assets/img/logo.png" alt="Baby Twinkles" style={{ height: "80px" }} />
              </Link>
            </div>
            <a
              href="tel:+918074597649"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor: "#fff",
                color: "#000",
                textDecoration: "none",
                marginLeft: "auto"
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.09 8.32 8.82 8.59L6.62 10.79Z" />
              </svg>
            </a>
          </div>
          <div className="company-logo d-none d-lg-block">
            <Link to="/">
              <img src="/assets/img/logo.png" alt="Baby Twinkles" style={{ height: "90px" }} />
            </Link>
          </div>
          <div className="main-menu">
            <ul className="menu-list">
              <li>
                <Link to="/" className="drop-down">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="drop-down">
                  About
                </Link>
              </li>

              <li>
                <Link to="/gallery" className="drop-down">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/blogs" className="drop-down">
                  Blogs
                </Link>
              </li>
              <li>
                <Link to="/contact" className="drop-down">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="nav-right d-lg-flex d-none jsutify-content-end align-items-center">
            <a
              className="primary-btn3 d-lg-flex d-none align-items-center gap-2"
              href="tel:+918074597649"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.09 8.32 8.82 8.59L6.62 10.79Z" />
              </svg>
              +91 8074 597 649
            </a>
          </div>
        </header>
      </div>
    </>
  );
};

export default Header;
